module.exports = __webpack_public_path__ + "media/images/contentaproval-3dfbba248e121922e194394005eca00b.svg";